import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

var _process, _process$env;

import React from 'react';
import { DebuggerView } from './Debugger.styles';
var IS_DEV_ENV = process && ((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.NODE_ENV) === 'development';

function Debugger(_ref) {
  var _ref$__force = _ref.__force,
      __force = _ref$__force === void 0 ? false : _ref$__force,
      otherProps = _objectWithoutProperties(_ref, ["__force"]);

  if (!IS_DEV_ENV && !__force) return null;
  return /*#__PURE__*/React.createElement(DebuggerView, otherProps);
}

export default /*#__PURE__*/React.memo(Debugger);